<template>
  <CalculationElementLayout
    :node-id="nodeId"
    :child-elements="['part']" />
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";

const route = useRoute();

const nodeId = computed(() => route.params.nodeId);
</script>
